// Polices price-eat disponibles sur les clients (Android + webapp).
// La `value` DOIT correspondre au nom de fichier .ttf embarqué côté client
// (Android: app/src/main/assets/fonts/<value>.ttf ; webapp: @font-face famille <value>).
// => Ajouter une police ici ne suffit PAS : il faut aussi livrer le .ttf sur les
//    clients (voir TODO "Fonts price-eat — distribution CMS → clients").
export const PRICE_EAT_FONTS = [
    { value: 'roboto_regular', label: 'Roboto' },
    { value: 'anton', label: 'Anton' },
    { value: 'dosis-book', label: 'Dosis Book' },
    { value: 'gearedslab', label: 'Geared Slab' },
    { value: 'gearedslab-extrabold', label: 'Geared Slab ExtraBold' },
    { value: 'bebrush', label: 'Bebrush' },
    { value: 'dirty_headline', label: 'Dirty Headline' },
    { value: 'mark_my_words', label: 'Mark My Words' },
    { value: 'spot_normal', label: 'Spot Normal' },
    { value: 'farsonstamp', label: 'Farson Stamp' },
    // Ajoutées avec l'APK Android (assets/fonts/).
    { value: 'a_love_of_thunder', label: 'A Love of Thunder' },
    { value: 'hackney_vector', label: 'Hackney Vector' },
    { value: 'iciel_alina', label: 'iCiel Alina' },
];

// Normalise un nom saisi/importé vers le format attendu par les clients
// (minuscules, espaces -> underscore), aligné sur la webapp (OverlayLayer.ts).
export function slugFont(name) {
    return String(name || '')
        .replace(/\.(ttf|otf)$/i, '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_');
}

/**
 * Déclare les @font-face du WYSIWYG à partir de la liste ci-dessus (source de vérité unique).
 *
 * Pourquoi en JS et pas dans un .css : les .ttf vivent dans `public/fonts/` (servis statiquement,
 * URL stable `/fonts/<value>.ttf` — utile pour la future distribution CMS -> clients). Or webpack
 * (CRA) tente de RÉSOUDRE `url('/fonts/x.ttf')` depuis un fichier CSS et casse le build. On injecte
 * donc les règles au runtime, en s'appuyant sur PUBLIC_URL (robuste si `homepage` change).
 *
 * Sans ces @font-face, l'aperçu retombait silencieusement sur sans-serif -> le WYSIWYG MENTAIT
 * (l'éditeur applique `fontFamily: '<value>'`, les clients résolvent la même chaîne).
 * Le navigateur ne télécharge que les polices réellement utilisées.
 */
const FONT_FACE_STYLE_ID = 'price-eat-font-faces';

export function injectPriceEatFontFaces() {
    if (typeof document === 'undefined') return;              // SSR / tests
    if (document.getElementById(FONT_FACE_STYLE_ID)) return;  // idempotent

    const base = `${process.env.PUBLIC_URL || ''}/fonts`;
    const css = PRICE_EAT_FONTS
        .map(({ value }) =>
            `@font-face{font-family:'${value}';` +
            `src:url('${base}/${value}.ttf') format('truetype');` +
            `font-display:swap;}`)
        .join('\n');

    const style = document.createElement('style');
    style.id = FONT_FACE_STYLE_ID;
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
}

// Effet de bord volontaire : tout module qui importe la liste obtient aussi les polices.
injectPriceEatFontFaces();
